"use client";

import * as React from "react";
import { Check } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const benefits = [{
  title: "Segurança Total",
  description: "Viaje com a tranquilidade de quem tem cada detalhe monitorado por especialistas, garantindo sua proteção absoluta em qualquer destino do mundo."
}, {
  title: "Conforto Premium",
  description: "Selecionamos criteriosamente as melhores hospedagens e transportes para que sua única preocupação seja desfrutar o melhor da jornada com elegância."
}, {
  title: "Grupos Exclusivos",
  description: "Conecte-se com outras mulheres que compartilham seus interesses e valores em roteiros desenhados para vivências culturais autênticas e memoráveis."
}, {
  title: "Suporte 24h",
  description: "Nossa equipe dedicada está sempre a um clique de distância, oferecendo auxílio imediato e personalizado durante toda a sua viagem dos sonhos."
}];
interface AnimatedCardProps {
  benefit: {
    title: string;
    description: string;
  };
  index: number;
  "data-index": number;
}
function AnimatedCard({
  benefit,
  index,
  "data-index": dataIndex
}: AnimatedCardProps) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <div data-section-id="118736" ref={ref} data-index={dataIndex} className={cn("transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <Card className="rounded-lg shadow-md bg-card p-0 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 overflow-hidden group">
        <div className="flex flex-col sm:flex-row items-start gap-4 px-6 py-4">
          <div className="bg-secondary/10 p-3 rounded-full shrink-0 group-hover:bg-secondary/20 transition-colors duration-300">
            <Check className="w-6 h-6 text-secondary" strokeWidth={2} />
          </div>
          <div className="pt-1">
            <h3 className="text-lg font-bold text-foreground mb-2">
              {benefit.title}
            </h3>
            <p className="text-muted-foreground text-sm leading-relaxed">
              {benefit.description}
            </p>
          </div>
        </div>
      </Card>
    </div>;
}
export default function PorqueEscolherANexora() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}